import { useEffect, useRef } from "react";
import styles from "./gradientBackground_TERM.module.css";

export default function GradientBackgroundTerm() {
  const bgRef = useRef(null);
  const cursorBlobRef = useRef(null);

  // Движение blob'а за курсором
  useEffect(() => {
    const element = cursorBlobRef.current;
    if (!element || typeof window === "undefined") return;

    const prefersReducedMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const handlePointerMove = (event) => {
      if (!cursorBlobRef.current || prefersReducedMotion) return;

      const { innerWidth, innerHeight } = window;

      const relX = event.clientX / innerWidth - 1; // -0.5 .. 0.5
      const relY = event.clientY / innerHeight - 1; // -0.5 .. 0.5

      const strength = 120; // насколько далеко blob уходит от центра

      cursorBlobRef.current.style.setProperty(
        "--cursor-x",
        `${relX * strength}px`
      );
      cursorBlobRef.current.style.setProperty(
        "--cursor-y",
        `${relY * strength}px`
      );
    };

    window.addEventListener("pointermove", handlePointerMove);
    return () => window.removeEventListener("pointermove", handlePointerMove);
  }, []);

  // Параллакс при скролле
  useEffect(() => {
    const bgElement = bgRef.current;
    if (!bgElement || typeof window === "undefined") return;

    const prefersReducedMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    let frameId = null;

    const updateScroll = () => {
      frameId = null;
      const scrollY =
        window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 5;

      // Чем больше коэффициент, тем сильнее эффект
      const offset = prefersReducedMotion ? scrollY * 0.02 : scrollY * 0.12;
      bgElement.style.setProperty("--scroll-offset", `${offset}px`);
    };

    const handleScroll = () => {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(updateScroll);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    // Первичная установка
    updateScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
    };
  }, []);

  return (
    <div ref={bgRef} className={styles.bg}>
      {/* Основные blob’ы */}
      <div className={`${styles.blob} ${styles.blob1}`} />
      <div className={`${styles.blob} ${styles.blob2}`} />
      <div className={`${styles.blob} ${styles.blob3}`} />

      {/* Дополнительные акценты */}
      <div className={`${styles.blob} ${styles.blob4}`} />
      <div className={`${styles.blob} ${styles.blob5}`} />

      {/* Декоративные элементы */}
      <div className={styles.ring} />
      <div className={styles.glowLine} />

      <div className={styles.sparkles}>
        <div className={styles.sparkle} />
        <div className={styles.sparkle} />
        <div className={styles.sparkle} />
        <div className={styles.sparkle} />
      </div>

      {/* Blob, который живёт от скролла + курсора */}
      <div
        ref={cursorBlobRef}
        className={`${styles.blob} ${styles.cursorBlob}`}
      />
    </div>
  );
}